<section class="smart-sprint">
  <div class="smart-sprint__pupil">
    <div class="smart-sprint__pupil__info">
      <span class="smart-sprint__pupil__info__logo"></span>
      <span class="smart-sprint__pupil__info__photo">
        <app-privilege-icon *ngIf="pupil"
          [student]="pupil"
          [lesson]="lesson">
        </app-privilege-icon>
      </span>
      <span class="smart-sprint__pupil__info__name">
        <b>{{ pupil?.surname }} {{ pupil?.name }}</b>
      </span>
    </div>
    <div class="smart-sprint__pupil__settings" *ngIf="selectedBox">
      <div class="smart-sprint__pupil__settings__description" *ngIf="selectedBox.smart_sprints.length">
        <span>секунд</span>
        <span>{{ currentCurrency.plural_name_more_5 }}</span>
      </div>
      <div class="smart-sprint__pupil__settings__list">
        <ul *ngIf="selectedBox.smart_sprints.length">
          <li *ngFor="let sprint of boxSmartSprints; let i = index;">
            <span class="smart-sprint__pupil__settings__list__item-number">{{ i + 1 }}.</span>
            <div class="smart-sprint__pupil__settings__list__item">
              <span class="smart-sprint__pupil__settings__list__item__duration"><b>{{ sprint.duration }}</b></span>
              <span>---></span>
              <span class="smart-sprint__pupil__settings__list__item__reward"><b>{{ sprint.reward }}</b></span>
            </div>
          </li>
        </ul>
        <p *ngIf="!selectedBox.smart_sprints.length" class="default_reward">
          <b>{{ selectedBox?.reward_no_risk }} {{ currentCurrency?.title }} </b> за верное решение
        </p>
      </div>
    </div>
    <!-- <div class="smart-sprint__pupil__back-button">
      <button
          class="smart-sprint__pupil__back-button__element"
          mat-raised-button matTooltip="Вернуться назад к выбору студентов"
          (click)="exitPage()"
          matTooltipPosition="above">
          &crarr; Назад</button>
    </div> -->
  </div>
  <div class="smart-sprint__card">
    <div *ngIf="!selectedBox" class="smart-sprint__card__no-selected">
      <span class="smart-sprint__card__no-selected__title">Выбери бокс</span>
      <span class="smart-sprint__card__no-selected__indicator"></span>
    </div>
    <div *ngIf="selectedBox" class="smart-sprint__card__selected">
      <div class="smart-sprint__card__selected__box">
        <span class="smart-sprint__card__selected__box__level" *ngIf="selectedBox?.level !== 9">Уровень {{ selectedBox?.level }}</span>
        <span class="smart-sprint__card__selected__box__level" *ngIf="selectedBox?.level === 9">Уровень 0</span>
      </div>
      <div class="smart-sprint__card__selected__title">
        <h4>Тип заданий:</h4>
      </div>
      <div class="smart-sprint__card__selected__preview">
          <div *ngIf="cardTemplate; else cardLoading" class="smart-sprint__card__selected__preview__template">
            <app-preview-img
              [cardsFormat]="selectedBox.cards_format"
              [box]="selectedBox"
              [boxLevels]="boxLevels"
              [cardTemplate]="cardTemplate"
              [lessonDate]="lessonDate"
              [character]="character">
            </app-preview-img>
          </div>
          <ng-template #cardLoading>
            <div class="smart-sprint__card__selected__preview__loading">
              <span class="smart-sprint__card__selected__preview__loading__image"></span>
              <span class="smart-sprint__card__selected__preview__loading__message">Загрузка..</span>
            </div>
          </ng-template>
      </div>
      <div class="smart-sprint__card__selected__button">
        <button
          class="smart-sprint__card__selected__button__element"
          mat-raised-button matTooltip="При нажатии Смарт Спринт начнется"
          (click)="startSprint()"
          matTooltipPosition="above"
          color="primary">Выбрать</button>
      </div>
    </div>
  </div>
  <div class="smart-sprint__boxes">
    <ul class="smart-sprint__boxes__list">
      <li *ngFor="let item of boxes">
        <div class="smart-sprint__boxes__list__item__wrapper" [class.active-wrapper]="selectedBox && item?.id === selectedBox?.id">
          <div class="smart-sprint__boxes__list__item" [class.active]="selectedBox && item?.id === selectedBox?.id" (click)="changeSelectedBox(item)">
            <span class="smart-sprint__boxes__list__item__box">
              {{ item.title }}
            </span>
          </div>
        </div>
      </li>
    </ul>
  </div>
</section>
